import React from 'react'
import Skeleton from 'react-loading-skeleton'

import ReachCell from './ReachCell'

import { DATA_REACH } from '../../const/sort'
import { reachColStyles } from '../../const/tableColumnsSize'

const ReachCol = ({ classes, editProductId, updatingProductIds, isAmendProcess, isAmendment }) => {
  return {
    header: 'Reach',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: reachColStyles,
    attributes: { 'data-copy': DATA_REACH },
    Cell: productValues => {
      const productRowId = productValues.id
      const isInEditMode = editProductId === productRowId
      const isProductLoading = productValues.isLoading
      // Reach is updated on BE based on selected periods, so we show loading state until the data is updated
      // on contract data update the useReachData hook is triggered and updates for the product data reach value
      const productIsUpdating = updatingProductIds.includes(productRowId)

      // just show loader for amendment process, as reach is calculated on BE, and we make the request to BE only when Generate Amendment is submitted
      if (isAmendProcess || isProductLoading || productIsUpdating) {
        return <Skeleton width="100%" />
      }

      // don't show the reach for the product if it's not selected or in edit mode(to avoid not correct data representation if periods or quantity is changed)
      const isProductSelected = !!productValues.data
      const showReach = isProductSelected && !isInEditMode
      return showReach ? (
        <ReachCell isInEditMode={isInEditMode} productValues={productValues} isAmendment={isAmendment} />
      ) : null
    }
  }
}

export default ReachCol
